import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { fonts,colors } from '../common/mixins.js';

const Title = styled.div`
 ${fonts.smallTitle()};
    font-size: 16px;
`;

const LightBold = styled.div`
    ${fonts.lightGrayText()};
    font-weight:600;
    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const Light = styled.div`
    ${fonts.lightGrayText()};
    font-size: 14px;
`;

const Container= styled.div`
width:100%;
background-color:white;
padding:16px;
border-radius:8px;
`;

const Top = styled.div`
width:100%;
`;

const MiddleContainer = styled.div`
width:100%;
display:flex;
flex-direction:column;
gap:4px;
padding:16px 0;
border-bottom:1px solid #EDF1F6;`;

const FlexContainer = styled.div`
paddig:8px 0;
width:100%;
display:flex;
gap:24px;
align-items:center;
justify-content:space-between;
`;

const Bottom = styled.div`
width:100%;
padding-top:16px;
`;

export default function BillingInfo({ data}) {
    const { ticketsAmount, productsAmount, serviceFee, donationFee, totalAmount } = data;
    return (
        <Container id="billingInfo">
            <Top><Title>{orderdetails_resources.BillingInfo}</Title></Top>
            <MiddleContainer>
                <FlexContainer>
                    <Light>{orderdetails_resources.TicketsCharge}</Light>
                    <Light id="ticketsAmount">{ticketsAmount}</Light>
                </FlexContainer>
                {productsAmount && <FlexContainer>
                    <Light>{orderdetails_resources.ProductsCharge}</Light>
                    <Light id="productsAmount">{productsAmount}</Light>
                </FlexContainer>}
                {serviceFee && <FlexContainer>
                    <Light>{orderdetails_resources.ServiceFee}</Light>
                    <Light id="serviceFee">{serviceFee}</Light>
                </FlexContainer>}
                {donationFee && <FlexContainer>
                    <Light>{orderdetails_resources.AdditionalCharge}</Light>
                    <Light id="donationFee">{donationFee}</Light>
                </FlexContainer>}
            </MiddleContainer>

            <Bottom>
                <FlexContainer>
                    <LightBold>{orderdetails_resources.Total}</LightBold>
                    <Title id="total">{totalAmount}</Title>
                </FlexContainer>
            </Bottom>
        </Container>

    );
}



